exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Overview-module__wrapper___2Wffb{display:grid;gap:1rem;justify-items:center}@media screen and (min-width:1325px){.Overview-module__wrapper___2Wffb{display:block;width:200px;height:200px;position:absolute}}", ""]);

// exports
exports.locals = {
	"wrapper": "Overview-module__wrapper___2Wffb"
};